import 'es6-promise';
import 'isomorphic-fetch';
import * as _ from 'lodash';
import * as actions from './index';
import { ISearchCriteria } from '../state-helpers/search-criteria'
import { ISort } from '../state-helpers/sorts'
import { ISearchAppState } from '../reducers/index'
import { IAutocompleteResults, IHit } from '../state-helpers/autocomplete-results';

const AUTOCOMPLETE_URL = (window as any).searchBox && (window as any).searchBox.findIndexUrl + '_autocomplete';
const AUTOCOMPLETE_SIZE = 5;

const fetch = (searchTerm: string) => {
    let url = getAutoCompleteUrl(searchTerm);
    return window.fetch(url)
        .then(function (response) {
            if (response.status === 504) {
                const errorMsg = new Error("Failed to fetch");
                errorMsg.message = "Failed to fetch";
                throw errorMsg;
            }
            // Catch the bad response
            else if (response.status >= 400) {
                const errorMsg = new Error("Bad response");
                errorMsg.message = "Bad response";
                throw errorMsg;
            }
            return response.json();
        });
};

let autocompleteCache = _.memoize(fetch);

function removeAutoCompleteDuplicates(data: IAutocompleteResults) {
    var resultItems = [];
    var resultDups = [];

    for (var i = 0; i < data.hits.length; i++) {
        if (resultDups.indexOf(data.hits[i].query.trim()) === -1) {
            resultItems.push({ query: data.hits[i].query.trim() } as IHit);
            resultDups.push(data.hits[i].query.trim());
        }
    }

    data.hits = resultItems
    return data;
}

function getAutoCompleteUrl(searchTerm) {
    var prefix = encodeURIComponent(searchTerm);
    return AUTOCOMPLETE_URL + '?prefix=' + prefix + '&size=' + AUTOCOMPLETE_SIZE;
}

export function fetchAutocompleteResults(searchTerm: string) {
    return (dispatch, getState) => {
        if (searchTerm.length > 2) {
            autocompleteCache(searchTerm)
                .then(data => dispatch(actions.getAutocompleteResults(removeAutoCompleteDuplicates(data))));
        }
        else dispatch(actions.getAutocompleteResults(null));
    }
}

export function getAutocompleteResults(term: string, onDataLoaded: (data: IAutocompleteResults) => void) {
    autocompleteCache(term).then(data => onDataLoaded(removeAutoCompleteDuplicates(data)));
}